import * as React from "react";
import { LoanHistoryView } from "@tlc/ls2pac/app/views/myAccountViews/accountActivitySubViews/LoanHistoryView";
import { useAccount } from "../../Account";
import useBackToLink from "../resource/useBackToLink";
import { useLanguage } from "../../Language";
import { useLocation } from "react-router-dom";

export const BorrowerHistoryView: React.FC = () => {
    const { accountSummary, user, patron } = useAccount();
    const { translate } = useLanguage();
    const location = useLocation();
    useBackToLink(translate("loanHistory"), location);
    const containerId = "borrowerHistoryContainer";

    React.useEffect(() => {
        const view = new LoanHistoryView();
        view.load(
            { accountSummary, patron },
            user,
            document.getElementById(containerId),
            "loanHistory"
        );
        return () => {
            view?.cleanup();
        };
    }, [accountSummary, user, patron]);

  return <div id={containerId}></div>;
};
